import { ReactElement } from "react";
import classNames from "classnames";
import styles from "../ActivityFeedSpaces.module.less";
import { ExpandedStackBar } from "./ExpandedStackBar";

export type ExpandedStackHeaderActivityFeedItemProps = {
	stackId: string;
	title: string;
	hasReducedPadding: boolean;
	canStackBeDeletedByUser: boolean;
	onCollapse(): void;
	onDelete(): void;
	onMute(): void;
};

export const ExpandedStackHeaderActivityFeedItem = (props: ExpandedStackHeaderActivityFeedItemProps): ReactElement => {
	const {
		stackId,
		title,
		hasReducedPadding,
		canStackBeDeletedByUser,
		onCollapse,
		onDelete,
		onMute
	} = props;

	return (
		<div className={classNames(
			styles.expandedStackHeaderItem,
			{ [styles.expandedStackHeaderItem_reduced]: hasReducedPadding }
		)}>
			<ExpandedStackBar
				stackId={stackId}
				title={title}
				canStackBeDeletedByUser={canStackBeDeletedByUser}
				onCollapse={onCollapse}
				onDelete={onDelete}
				onMute={onMute}
			/>
		</div>
	);
};

ExpandedStackHeaderActivityFeedItem.displayName = "ExpandedStackHeaderActivityFeedItem";